import React from "react";
import { useHistory } from "react-router-dom";
import { store } from "../..";
import { ReactComponent as PaymentHistory } from "../../assets/icons/PaymentHistory.svg";
import { ReactComponent as UsageManager } from "../../assets/icons/UsageManager.svg";
import { ReactComponent as WaitingForPayment } from "../../assets/icons/WaitingForPayment.svg";
import { loginPage } from "../../Redux/Actions/Authentication";
const texts = {
  header: "چرا کنتور را انتخاب کنیم؟",
  desc:
    "کنتور یک برنامه و سامانه بسیار کاربردی ، آسان و رایگان است که با توجه به حذف قبوض کاغذی شرکت های خدماتی شما را از صدور قبض های مختلف شما و تاریخ مهلت پرداخت مطلع می کند و شما با این برنامه میتوانید با آرامش خیال آنها را مدیریت و پرداخت کنید ، همچنین آرشیو پرداختی های قبلی خود را ببینید و از میزان مصرف قبض ها جداگانه و یا تجمیعی گزارش گیری کنید."
};

const descColItems = [
  {
    header: "در انتظار",
    text:
      "در این قسمت شما میتوانید کلیه قبوضی را که از طریق سامانه و یا اپلیکیشن کنتور پرداخت کرده‌اید را در بازه های زمانی مختلف مشاهده کنید",
    icon: <WaitingForPayment />,
    path: "/waiting"
  },
  {
    header: "مدیریت مصرف",
    text:
      "در این قسمت میزان مصرف قبض های مورد نظر را در زمان های مختلف بررسی و گزارش های مختلف را دریافت و مصرف خود را مدیریت کنید",
    icon: <UsageManager />,
    path: "/usage"
  },
  {
    header: "سوابق",
    text:
      "در این قسمت شما میتوانید کلیه قبوضی را که از طریق سامانه و یا اپلیکیشن کنتور پرداخت کرده‌اید را در بازه های زمانی مختلف مشاهده کنید",
    icon: <PaymentHistory />,
    path: "/history"
  }
];

const DescriptionColumn = ({
  Icon,
  headerText,
  text,
  history,
  path,
  isLogin
}) => {
  const onClick = () => {
    isLogin ? history.push(path) : store.dispatch(loginPage(true));
  };
  return (
    <div className="descriptionColumn" onClick={() => onClick()}>
      {Icon}
      <span className="descColHead">{headerText}</span>
      <span>{text}</span>
    </div>
  );
};

const Description = ({ ...props }) => {
  const history = useHistory();
  const { isLogin } = props;

  return (
    <div className="description">
      <span>{texts.header}</span>
      <span>{texts.desc}</span>
      <div className="descriptionColumnDiv">
        {descColItems.map((i, index) => {
          return (
            <DescriptionColumn
              history={history}
              path={i.path}
              isLogin={isLogin}
              headerText={i.header}
              Icon={i.icon}
              text={i.text}
              key={`#Description${index}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Description;
